<div class="w-full flex flex-col gap-2">
  <ngx-form-factory
    [form]="form"
    [formFields]="fieldsService.resetPasswordFields"
    (keydown.enter)="onResetPassword()"
  />
  <div class="flex flex-row items-center justify-between w-full gap-4">
    <a [routerLink]="['/auth/login']">{{ 'auth.returnToLogin' | translate }}</a>
    <app-button
      [text]="'auth.resetPassword' | translate"
      (click)="onResetPassword()"
      size="small"
    ></app-button>
  </div>
</div>
